import { PATH } from '../constants';
import { ArticleItemProps, ArticleResponseItem } from '../types';

const convertArticleItem = (
  articles: ArticleResponseItem[]
): ArticleItemProps[] => {
  return articles.map((article) => ({
    id: article.id,
    href: `${PATH.DETAIL}/${article.id}`,
    title: article.title,
    category: article.category[0].name,
    categoryFlag: article.category[0].flag,
    categoryHref: `${PATH.LIST}/${article.category[0].flag}`,
    description: article.description ?? '',
    thumbnail: article.thumbnail_image,
    articleInfo: {
      time: article.read_time || 0,
      date: article.repr_date_published,
      isPopular: article.is_popular_news,
    },
    author: {
      name: article.author.name,
      href: `${PATH.HOME}/@${article.author.author_url_identifier}`,
      imgUrl: article.author.image_url,
    },
    isScrapped: article.is_news_scrapped,
  }));
};

export default convertArticleItem;
